<section class="v3-ai-card">
  <div class="v3-ai-card__top">
    <div class="v3-ai-card__heading">
      <span class="v3-ai-card__heading-icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.5L13.6 7.8 18.9 9.4 13.6 11 12 16.3 10.4 11 5.1 9.4 10.4 7.8z"/>
          <circle cx="18.5" cy="4.5" r="1.2"/>
          <circle cx="5.5" cy="17.5" r="0.9"/>
        </svg>
      </span>
      <h2 class="v3-ai-card__title">
        {{ titleKey | translate }}
      </h2>
      <span class="v3-ai-card__beta" aria-label="Beta">BETA</span>
    </div>

    <ng-container *ngIf="state === 'ready' && !canRegenerate; else regenerateAction">
      <span class="v3-ai-card__cooldown">
        {{ 'ai-summary.regenerate-cooldown' | translate : { minutes: minutesUntilRegen } }}
      </span>
    </ng-container>
    <ng-template #regenerateAction>
      <button
        type="button"
        class="v3-ai-card__regenerate"
        [disabled]="state === 'loading' || !canRegenerate"
        (click)="generate.emit()"
      >
        <ng-container *ngIf="state === 'ready' || state === 'error'; else generateLabel">
          {{ regenerateKey | translate }}
        </ng-container>
        <ng-template #generateLabel>
          {{ generateKey | translate }}
        </ng-template>
      </button>
    </ng-template>
  </div>

  <div class="v3-ai-card__stats" *ngIf="stats?.length">
    <div
      class="v3-ai-stat"
      *ngFor="let chip of stats"
      [class.v3-ai-stat--success]="chip.variant === 'success'"
      [class.v3-ai-stat--warning]="chip.variant === 'warning'"
      [class.v3-ai-stat--danger]="chip.variant === 'danger'"
    >
      <span class="v3-ai-stat__value">{{ chip.value }}</span>
      <span class="v3-ai-stat__label">{{ chip.labelKey | translate }}</span>
    </div>
  </div>

  <p class="v3-ai-card__summary" *ngIf="summary">{{ summary }}</p>

  <div class="v3-ai-card__loader" *ngIf="state === 'loading'">
    <div class="spinner-border spinner-border-sm" role="status"></div>
    <span>{{ loadingKey | translate }}</span>
  </div>

  <p class="v3-ai-card__error" *ngIf="state === 'error' && errorKey">
    {{ errorKey | translate }}
  </p>

  <p class="v3-ai-card__error" *ngIf="state === 'no-answers' && noAnswersKey">
    {{ noAnswersKey | translate }}
  </p>

  <p class="v3-ai-card__hint" *ngIf="state === 'idle' && hintKey">
    {{ hintKey | translate }}
  </p>
</section>
